/**
 * Polyfill created for the Element.toggleAttribute feature.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute
 *
 * The feature is well supported by the target browsers however many JSDOM environments still do not support it
 * To prevent
 *
 */
export function applyToggleAttributePolyFill() {
    if (!('toggleAttribute' in Element.prototype)) {
        // Legacy environment, load toggleAttribute polyfill.
        Element.prototype.toggleAttribute = function (attributeName, forceValue) {
            if (typeof forceValue === 'undefined') {
                if (this.hasAttribute(attributeName))
                    this.removeAttribute(attributeName);
                else
                    this.setAttribute(attributeName, '');
            }
            else if (forceValue)
                this.setAttribute(attributeName, '');
            else
                this.removeAttribute(attributeName);
            return this.hasAttribute(attributeName);
        };
    }
}
